module.exports = __webpack_public_path__ + "static/media/29ADMSPC21.fda3a11b.jpg";